const TRUE_VALUES = new Set(['1', 'true', 'on', 'yes', 'enabled']);
const FALSE_VALUES = new Set(['0', 'false', 'off', 'no', 'disabled', '']);

export function isEnabled(value, fallback = false) {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    return value === 1;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();

    if (TRUE_VALUES.has(normalized)) {
      return true;
    }

    if (FALSE_VALUES.has(normalized)) {
      return false;
    }
  }

  return fallback;
}

export function normalizeShowOn(value) {
  const normalized = String(value || '').trim().toLowerCase();

  if (normalized === 'mobile' || normalized === 'desktop' || normalized === 'both') {
    return normalized;
  }

  return 'both';
}

export function getShowOnClass(value) {
  const showOn = normalizeShowOn(value);

  if (showOn === 'mobile') {
    return 'd-block d-lg-none';
  }

  if (showOn === 'desktop') {
    return 'd-none d-lg-block';
  }

  return '';
}
